module.exports = __webpack_public_path__ + "static/image-66dca99246a52c4f519ddbb00fdff424.jpg";